<template>
  <div class="invoice-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Informações d{{ letter }} {{ termSingular }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <p class="title">Dados da transação</p>
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">ID da transação</label><br/>
                    <span class="preview">{{ invoice != null ? invoice.zoop_id : '&nbsp;' }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Data</label><br/>
                    <span class="preview">{{ invoice != null ? moment(invoice.created_at).format('DD/MM/YYYY') : '&nbsp;' }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Conta de cobrança</label><br/>
                    <span class="preview" v-if="invoice == null">&nbsp;</span>
                    <router-link v-else tag="span" :to="'/cobrancas/contas-de-cobranca/'+invoice.seller_id" class="preview link">{{ (invoice.seller.company_name != null ? invoice.seller.company_name : invoice.seller.name) }}</router-link>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Tipo de cobrança</label><br/>
                    <span class="preview">{{ invoice != null ? (invoice.appointment != null ? 'Agendamento' : '') : '&nbsp;' }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Método de pagamento</label><br/>
                    <span class="preview">{{ invoice != null ? (invoice.payment_method == 'boleto' ? 'Boleto' : (invoice.card_brand + ' ' + invoice.card_bin + ' ****')) : '&nbsp;' }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Valor</label><br/>
                    <span class="preview">{{ invoice != null ? ('R$ ' + formatPrice(invoice.value_in_cents/100.0)) : '&nbsp;' }}</span>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Tarifa</label><br/>
                    <span class="preview">{{ invoice != null ? (invoice.fees_in_cents != null ? ('R$ ' + formatPrice(invoice.fees_in_cents/100.0)) : '-') : '&nbsp;' }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Identificador</label><br/>
                    <span class="preview">{{ invoice != null ? (invoice.payment_method == 'boleto' ? invoice.boleto_document_number : (invoice.card_nsu != null ? (invoice.card_nsu + '-' + invoice.card_auth) : '&nbsp;')) : '&nbsp;' }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Status</label><br/>
                    <span class="preview">{{ invoice != null ? invoiceStatusOptions.find(g => g.value == invoice.status).name : '&nbsp;' }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="invoice != null && invoice.appointment != null">
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <p class="title">Dados do agendamento</p>
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Data / Hora</label><br/>
                    <span class="preview">{{ moment(invoice.appointment.start_datetime).format('DD/MM/YYYY HH:mm') }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Profissional</label><br/>
                    <router-link tag="span" :to="'/profissionais/'+invoice.appointment.professional.id" class="preview link">{{ invoice.appointment.professional.name }}</router-link>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Paciente</label><br/>
                    <router-link tag="span" :to="'/pacientes/'+invoice.appointment.patient.id" class="preview link">{{ invoice.appointment.patient.name }}</router-link>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <label class="cj-label">Celular</label><br/>
                    <span class="preview">{{ invoice.appointment.patient.cellphone }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Convênio</label><br/>
                    <span class="preview">{{ invoice.appointment.health_plan.name }}</span>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Status</label><br/>
                    <span class="preview">{{ appointmentStatusOptions.find(g => g.value == invoice.appointment.status).name }}</span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="invoice != null && invoice.payment_method != 'boleto' && invoice.status == 'succeeded' && canRemove">
          <b-col cols="12" md="6">
            <div class="box-cj">
              <div class="header">
                <p class="title">Estornar {{ termSingular }}</p>
              </div>
              <div class="content">
                <validation-observer ref="voidForm" v-slot="{ invalid }">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Informe o ID d{{ letter }} {{ termSingular }}</label>
                      <validation-provider :name="'ID  d'+letter+' '+termSingular"  v-slot="{ errors }">
                        <b-form-input type="text" v-model="voidForm.verification" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </validation-observer>
              </div>
              <div class="footer">
                <b-button variant="danger" class="mr-3" @click="voidInvoice" block :disabled="invoice.zoop_id != voidForm.verification">Estornar {{ termSingular }}</b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        termSingular: 'transação',
        termPlural: 'transações',
        url: 'transacoes',
        letter: 'a',
        newTerm: 'cadastrar-transacao',
        module: 'sellers',

        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        invoiceStatusOptions: [
          { value: 'new', name: 'Novo' },
          { value: 'pending', name: 'Pendente' },
          { value: 'pre_authorized', name: 'Pré-autorizado' },
          { value: 'succeeded', name: 'Pago' },
          { value: 'failed', name: 'Recusado' },
          { value: 'reversed', name: 'Revertido' },
          { value: 'canceled', name: 'Cancelado' },
          { value: 'refunded', name: 'Reembolsado' },
          { value: 'dispute', name: 'Em disputa' },
          { value: 'charged_back', name: 'Devolvido' }
        ],

        appointmentStatusOptions: [
          { value: 'SCHEDULED', name: 'Agendado' },
          { value: 'CONFIRMED', name: 'Confirmado' },
          { value: 'CANCELED', name: 'Cancelado' },
          { value: 'MISSED', name: 'Faltou' },
          { value: 'SHOWEDUP', name: 'Compareceu' },
          { value: 'ATTENDED', name: 'Atendido' }
        ],

        invoice: null,

        voidForm: {
          verification: ''
        }
      }
    },
    async mounted () {
      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.canAdd = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR'?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.$route.params.id != this.newTerm) {
        await this.api.getInvoice(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          this.invoice = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Invoice', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/cobrancas/' + this.url});

          this.$swal('Ops...', 'Não conseguimos carregar esta ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Invoice', err.response);
        });
      } else {
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);
    },
    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      async voidInvoice() {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação é irreversível!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, estornar ' + this.letter + ' ' + this.termSingular + '!',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if (res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;

            let voidData = {
              verification: this.voidForm.verification
            };

            this.api.voidInvoice(this.$route.params.id, voidData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi estornada com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/cobrancas/' + this.url});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao estornar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Void Invoice', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos estornar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 400: msg = err.response.data.message; break;
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Void Invoice', err.response);
            });
          }
        });
      },

      goBack() {
        this.$router.push({path: '/cobrancas/' + this.url});
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .invoice-form {
    padding: 20px 0;

    .preview {
      color: $waikawaGray;

      &.link {
        cursor: pointer;

        &:hover {
          color: $curiousBlue;
          text-decoration: underline;
        }
      }
    }
  }
</style>
